import { AvailableWriteProviders, EWalletId } from '@ankr.com/provider';

import { getProviderManager } from 'modules/core';

import { getApplicationData } from '../../auth/utils/getApplicationData';
import { api } from '../api';
import { setWalletId } from '../authSlice';
import { cacheTags } from '../cacheTags';

export const {
  useConnectMutation,
  endpoints: { connect },
} = api.injectEndpoints({
  endpoints: build => ({
    connect: build.mutation<boolean, EWalletId>({
      queryFn: async walletId => {
        const instance = await getProviderManager();

        if (walletId === EWalletId.trust) {
          try {
            await instance.getProvider(
              AvailableWriteProviders.ethCompatible,
              walletId,
            );
          } catch {
            // need for trust wallet mobile
            return { data: false };
          }
        } else {
          await instance.getProvider(
            AvailableWriteProviders.ethCompatible,
            walletId,
          );
        }

        return { data: true };
      },
      onQueryStarted: async (walletId, { dispatch, queryFulfilled }) => {
        await queryFulfilled;
        localStorage.setItem('walletId', walletId);
        dispatch(setWalletId(walletId));
        void getApplicationData(dispatch);
      },
      invalidatesTags: [
        cacheTags.account,
        cacheTags.balance,
        cacheTags.taskData,
        cacheTags.chainData,
      ],
    }),
  }),
});
